/**
 * Mockup preview — composites the result image into the three POD product
 * categories (T-shirt black/white · Mug · Poster, H-2026-09-12-127 Task D)
 * client-side and shows them as a tabbed preview immediately under the Result
 * slot. Click a tile → drops the user into Designer mode with the result
 * image pre-loaded (the existing make-product POD chain).
 *
 * Tab UI lives in ./mockup-tabs.js; composite + manifest in
 * `apps/creator-hub/src/utils/mockup-composite.js` (shared with the F4
 * client-handler `cachedTemplateHandler`).
 */

import { store } from '../../../core/store.js'
import { eventBus, EVENTS } from '../../../core/event-bus.js'
import { renderMockupTabs } from './mockup-tabs.js'
import { createLogger } from '../../../utils/logger.js'
const log = createLogger('create.dialog.mockup-preview')


let _mountEl = null

// ---- Public API ----

export function initMockupPreview() {
  _mountEl = document.getElementById('mockupTilesRow')
  if (!_mountEl) return

  store.subscribe('creation.result', (result) => {
    if (result?.url) renderMockupTiles(result.url, _mountEl).catch(() => {})
    else clearTiles()
  })
}

export async function renderMockupTiles(resultImageUrl, mountEl = _mountEl) {
  if (!mountEl) return
  await renderMockupTabs(mountEl, resultImageUrl, (template, url) => {
    store.setState('design.injectImageUrl', url)
    eventBus.emit(EVENTS.PRODUCT_SELECT, {
      templateId: template.id,
      resultUrl: url,
      productType: template.product_type,
    })
  }).catch((err) => log.warn('[mockup] tab render failed:', err.message))
}

export function clearTiles() {
  if (_mountEl) _mountEl.innerHTML = ''
}
